
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"d":"M50.44 41.2a4.16 4.16 0 01-3.61 6.24H5.17a4.16 4.16 0 01-3.61-6.24L22.39 5.08a4.17 4.17 0 017.22 0zM26 33.73a4 4 0 104 4 4 4 0 00-4-4zm-3.79-14.35l.64 11.8a1 1 0 001 1h4.22a1 1 0 001-1l.64-11.8a1 1 0 00-1-1.1h-5.5a1 1 0 00-1 1.1z","fill":"#ffbdc4","stroke":"#f43040","stroke-width":"1.667","opacity":".6"}})])
          )
        }
      }
    